import 'regenerator-runtime/runtime'
import "normalize.css/normalize.css"
import "./style.scss";
import * as THREE from "three";
import Vue from "vue";
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import VueRouter from 'vue-router'
import router from './app/router';
import MainApp from './app/app.vue'

import "bootstrap/dist/css/bootstrap.min.css";

Vue.use(VueRouter)

new Vue({
  el: '#app',
  render: h => h(MainApp),
  router
});







